import React, { Component } from 'react';
import { connect } from 'react-redux';

import * as Account from 'app/entities/Account';
import * as Profile from 'app/entities/Profile';
import AccountActions from 'app/account/AccountActions';
import AccountInfo from 'app/common/components/AccountInfo';

const mapStateToProps = state => {
  const primaryAccountId = Account.selectors.all.primaryAccountId(state);
  const currentProfile = Profile.selectors.all.currentProfile(state);
  return {
    accountId: primaryAccountId,
    title: Profile.selectors.normalizedNameOrLoading(currentProfile),
  };
};

const mapDispatchToProps = dispatch => ({
  onMount() {
    dispatch(AccountActions.loadAccount());
  },
});

class AccountInfoContainer extends Component {
  UNSAFE_componentWillMount() {
    this.props.onMount();
  }
  render() {
    return <AccountInfo {...this.props} />;
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(AccountInfoContainer);
